import CrudManager from "@/components/admin/CrudManager";

export default function AdminPartners() {
  return (
    <CrudManager
      title="Partners"
      subtitle="Beheer partners en sponsors"
      listEndpoint="/partners"
      adminEndpoint="/admin/partners"
      fields={[
        { name: "name", label: "Naam", required: true },
        { name: "logo_url", label: "Logo", type: "image" },
        { name: "website", label: "Website" },
        { name: "tier", label: "Categorie", type: "select", default: "partner", options: [{ value: "premium", label: "Premium partner" }, { value: "partner", label: "Partner" }, { value: "academic", label: "Academische partner" }] },
      ]}
      columns={[
        { key: "name", label: "Naam" },
        { key: "tier", label: "Categorie" },
        { key: "website", label: "Website" },
      ]}
    />
  );
}
